import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface FlashCSSStyle extends UIComponentCSSStyle
{
    getInnerWrapperDivCSSStyle():object;
    getMobileInnerWrapperDivCSSStyle():object;
    getTitleCSSStyle():object;
    getMobileTitleCSSStyle():object;
    getCloseIconDivCSSStyle():object;
    getMobileCloseIconDivCSSStyle():object;
    getCloseIconCSSStyle():object;
    getPackDetailsContentDiv():object;
    getMobilePackDetailsContentDiv():object;
    getTabPackDetailsContentDiv():object;
}

export class FlashCSSStyleImpl extends UIComponentCSSStyleImpl implements FlashCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            // backgroundColor: this.getResources().getColor(Colors.color_5),
            // borderRadius: "8px",
            // objectFit:"cover", backgroundImage :"url('" + this.getContext().getResources().getImage("flash.svg") + "')"
            // backgroundColor: this.getResources().getColor(Colors.color_5),
           
        };
    }

    getInnerWrapperDivCSSStyle(): object 
    {
        return {
            width:"100%",
            //  marginLeft:"-10px",
            //  paddingTop:"10px",
            //  paddingRight:"10px", 
             height:"auto",
            //  objectFit:"fill", 
            //  backgroundImage :"url('" + this.getContext().getResources().getImage("flash.svg") + "')"
        };
    }

    getMobileInnerWrapperDivCSSStyle():object{
        return{
            width:"100%",
            // paddingTop:"10px",
            // paddingRight:"10px",
             height:"600px",
            // objectFit:"cover",
            //  backgroundImage :"url('" + this.getContext().getResources().getImage("flash_mobile.svg") + "')"
        };
    }
    getTitleCSSStyle(): object {
        return {
            width: "87%",
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            paddingLeft: "60px",
            // paddingRight:"60px",
            textAlign:'center',
            fontSize: this.getResources().getFont(Fonts.h12),
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "10%",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "12px",
            marginTop: "22px",
            cursor: "pointer",
        };
    }


    getMobileTitleCSSStyle(): object {
        return {
            
            height: "40px",
            fontWeight: "300",
            letterSpacing: 0,
            // paddingLeft: "40px",
            // paddingRight:"60px",
            textAlign:'center',
            fontSize: "18px",
            color:this.getResources().getColor(Colors.color_19),
            lineHeight: "40px",
            marginTop: "7px",
        };
    }
    
    getMobileCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getTabPackDetailsContentDiv(): object {
        return{
            width:"100%",textAlign:"center",marginTop:"4px",height:"30px",lineHeight:"30px",color:"#000000",fontSize:"15px",fontFamily:this.getContext().getResources().getFontFamily()
        };
    }

    getMobilePackDetailsContentDiv(): object {
        return{
            width:"50%",marginLeft:"3px",textAlign:"center",marginTop:"4px",height:"30px",lineHeight:"30px",color:"#000000",fontSize:"13px",fontFamily:this.getContext().getResources().getFontFamily()        };
    }

    getPackDetailsContentDiv(): object {
        return{
            width:"100%",textAlign:"center",marginTop:"4px",height:"30px",lineHeight:"30px",color:"#000000",fontSize:"15px",fontFamily:this.getContext().getResources().getFontFamily()        };
    }
}    
   


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashpopup/flashcss.tsx